import React, { useCallback, useEffect, useState } from "react";
import { Select } from "semantic-ui-react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import ReportDashboardPage from "../../../assets/components/reports/ReportDashboardPage";
import Report from "../../../models/Report";

const membershipTypeOptions = [
    { key: "All", text: "All", value: "All" },
    { key: "Country", text: "Country", value: "Country" },
    { key: "Club", text: "Club", value: "Club" },
    { key: "Links", text: "Links", value: "Links" },
];

function MembersDashboard({ history, user }) {
    const [filters, setFilters] = useState({ membershipType: "All" });
    const fetchDashboardManifest = useCallback((params, signal) => {
        return Report.dashboardManifest("members", params, signal);
    }, []);
    const fetchDashboardBatch = useCallback((params, reportBatch, signal) => {
        return Report.dashboardBatch("members", params, reportBatch, signal);
    }, []);

    useEffect(() => {
        if (user.has("MASHIE_ADMIN") === false) {
            history.push("/members/list");
        }
    }, [history, user]);

    if (user.has("MASHIE_ADMIN") === false) {
        return null;
    }

    return (
        <>
            <div className='d-flex main'>
                <Header history={history} />
                <ReportDashboardPage
                    title='Members Dashboard'
                    subtitle='Member-level reporting aligned to MASHIE membership periods.'
                    fetchDashboardManifest={fetchDashboardManifest}
                    fetchDashboardBatch={fetchDashboardBatch}
                    filters={filters}
                    onFiltersChange={setFilters}
                    extraFilters={
                        <div className='row'>
                            <div className='col-sm-12 col-md-4 mb-3'>
                                <label className='with-input'>
                                    Membership type
                                </label>
                                <Select
                                    fluid
                                    options={membershipTypeOptions}
                                    value={filters.membershipType}
                                    onChange={(event, selection) =>
                                        setFilters({
                                            ...filters,
                                            membershipType: selection.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    }
                />
            </div>
            <Footer />
        </>
    );
}

export default MembersDashboard;
